@if (product$ | async; as product) {
  <div class="product-manufacturer__link-container">
    <a href="{{ product.warrantyLink }}" target="_blank">{{ product.warrantyText }}</a>
  </div>
  @if (product.manDistName) {
    <div class="product-manufacturer__link-container"
      >
      <a href="{{ product.manDistLink }}" target="_blank">{{ product.manDistName }}</a>
    </div>
  }
  @if (product.safetyName) {
    <div class="product-manufacturer__link-container"
      >
      <a href="{{ product.safetyLink }}" target="_blank">{{ product.safetyName }}</a>
    </div>
  }
}
